module.exports = __webpack_public_path__ + "assets/flags/pt.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/pt.svg
// module id = 510
// module chunks = 0